import {PrivateInterceptor} from "../../../Base/interceptors/PrivateInterceptor";


export const getResumenComprasTotal = () => {
    const respuesta = PrivateInterceptor('Compras/Resumen/total', 'POST');
    return respuesta;
}
export const getResumenComprasProducto = () => {
    const respuesta = PrivateInterceptor('Compras/Resumen/producto', 'POST');
    return respuesta;
}